import React from 'react'

const PartTen = () => {
  return (
    <><br/>
        <div className="row">
            <div className="col-xl-12 col-md-12">
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>หมวดที่ 7 การประกันผลงาน</strong>
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.1 หลังจากที่ผู้ว่าจ้างได้ลงนามตรวจรับมอบงานแล้ว ผู้รับจ้างจะออกหนังสือรับประกัน โดยมีรายละเอียดการรับปรกันผลงานดังนี้
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.1.1 กรณีโครงสร้างหลักของอาคาร 5 ปี
                </p> 
            </div>
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.1.2 กรณีที่เป็นส่วนครบ 1 ปี (ยกเว้นส่วนที่ผู้รับจ้างไม่ได้ทำ) หากเกิดความเสียหายในระยะเวลาที่กำหนด ผู้รับจ้างจะต้องทำการซ่อมแซมให้โดยไม่คิดค่าใช้จ่ายใดๆทั้งสิ้น ยกเว้นความเสียหายที่เกิดจากภัยธรรมชาติ เช่น วาตภัย,อัคคีภัย,อุทกภัย,แผ่นดินไหว,ความเสียหายจากสัตว์,แมลง,ความเสียหายจากความจลาจลโจรกรรม หรือความเสื่อมตามอายุของวัสดุ และงานก่อสร้างผู้รับจ้างตกลงจะรับทำการแก้ไขซ่อมแซมให้สามารถคิดค่าใช้จ่ายได้ตามความเหมาะสม
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.2 การรับประกันผลงานการก่อสร้าง หรือการรับประกันความชำรุดบกพร่องตามข้อ 7.1 นี้ เป็นอันสิ้นสุดลงทันที เมื่อผู้ว่าจ้างเหมาได้ทำการต่อเติมอาคารโดยผิดกฎหมาย หรือต่อเติมผิดหลักวิศวกรรม หรือใช้อาคารผิดปกติวิสัยในการอยู่อาศัยทั่วไป หรือใช้เป็นที่เก็บสินค้า หรือกิจการต่างๆนอกจากการใช้เป็นที่อยู่อาศัย
                </p> 
            </div>
        </div>
    </>  
  )
}

export default PartTen